import { Logo } from "../Logo";

export const JFooter = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden bg-[#0B2216] pt-40 pb-10">
    <img src="/img/vines-top.webp" alt="" aria-hidden="true" className="pointer-events-none absolute top-0 inset-x-0 w-full min-w-[900px] opacity-80" />
    <div className="relative max-w-[1400px] mx-auto px-5 md:px-10">
      <div className="grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Logo />
          <p className="text-[#C9D6C2] mt-6 max-w-sm text-sm leading-relaxed">Biotecnología avanzada optimizada por Inteligencia Artificial. Fertilizantes formulados con IA a partir del estudio de la mayoría de genéticas de cannabis.</p>
        </div>
        <div className="md:col-span-3 md:col-start-7 text-sm space-y-2">
          <p className="font-mono-d text-[11px] tracking-[0.22em] uppercase text-[#F2B441] mb-4">Contacto</p>
          <a data-testid="footer-email" href="mailto:info@nutritech.com" className="block text-[#F6EEDC] hover:text-[#F2B441] transition-colors">info@nutritech.com</a>
          <p className="text-[#C9D6C2]">Savi Nutri Tech, S.L.</p>
          <p className="text-[#C9D6C2]">Polígono Industrial La Molaina, nave 4<br />18240 Pinos Puente, Granada</p>
        </div>
        <div className="md:col-span-3 text-sm space-y-2">
          <p className="font-mono-d text-[11px] tracking-[0.22em] uppercase text-[#F2B441] mb-4">Aviso</p>
          <p className="text-[#C9D6C2]">Uso exclusivo para mayores de edad y conforme a la legislación local. Sigue siempre las instrucciones de la etiqueta.</p>
        </div>
      </div>
      <p className="font-label leading-none text-[#8CD05A]/10 text-[19vw] mt-14 select-none whitespace-nowrap" aria-hidden="true">JUNGLE</p>
      <div className="flex flex-wrap justify-between gap-4 text-xs text-[#C9D6C2] border-t border-[#F2B441]/20 pt-6 font-mono-d">
        <span>© 2026 Jungle Nutrient · Savi Nutri Tech, S.L.</span><span>Pago seguro: tarjeta (Redsys), Bizum, PayPal y transferencia</span>
      </div>
    </div>
  </footer>
);
